/* ============================================
   NEXTAP HEADER JS
   Sticky header, mobile menu, mega menu
   ============================================ */

(function() {
  'use strict';

  var header = document.querySelector('.nxt-header');
  if (!header) return;

  var scrollThreshold = 80;
  var lastScrollY = 0;
  var ticking = false;

  /* --- Sticky header scroll behavior --- */
  function onScroll() {
    lastScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  function updateHeader() {
    if (lastScrollY > scrollThreshold) {
      header.classList.add('nxt-header--scrolled');
    } else {
      header.classList.remove('nxt-header--scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateHeader();

  /* --- Mobile menu --- */
  var menuToggle = document.querySelector('.nxt-header__menu-toggle');
  var mobileMenu = document.querySelector('.nxt-mobile-menu');
  var menuClose = document.querySelector('.nxt-mobile-menu__close');
  var menuOverlay = document.querySelector('.nxt-mobile-menu__overlay');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    var firstLink = mobileMenu.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    document.body.style.overflow = '';
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.focus();
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);

  /* --- Mobile submenu toggle --- */
  document.querySelectorAll('.nxt-mobile-menu__submenu-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var submenu = this.nextElementSibling;
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (submenu) {
        submenu.style.display = isOpen ? 'none' : 'block';
      }
    });
  });

  /* --- Mega menu (desktop) --- */
  var megaToggles = document.querySelectorAll('.nxt-header__mega-toggle');

  megaToggles.forEach(function(toggle) {
    var megaMenu = toggle.nextElementSibling;

    toggle.addEventListener('mouseenter', function() {
      closeAllMegas();
      if (megaMenu) {
        megaMenu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    toggle.addEventListener('focus', function() {
      closeAllMegas();
      if (megaMenu) {
        megaMenu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    if (megaMenu) {
      megaMenu.addEventListener('mouseleave', function() {
        megaMenu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    toggle.closest('.nxt-header__nav-item')?.addEventListener('mouseleave', function() {
      if (megaMenu) {
        megaMenu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  function closeAllMegas() {
    document.querySelectorAll('.nxt-mega-menu').forEach(function(m) {
      m.classList.remove('is-open');
    });
    megaToggles.forEach(function(t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  /* --- Escape key handler --- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeAllMegas();
    }
  });

  /* --- Click outside to close megas --- */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nxt-header__nav-item')) {
      closeAllMegas();
    }
  });

})();
